import * as React from 'react';
import { WebComponent, UIRuntimeBuilder } from '@cian/mf-registry/browser';
import { Skeleton } from '../../../../shared/Microfrontend/components/Skeleton';
import { AppModulesWrapper } from '../../../../shared/AppModulesWrapper';
import { updateServicePickerWidgetStore } from '../../../../shared/ServicePickerWidget';
import { IExtendedContext } from '../../../types/extendedContext';
import {
  setMicrofrontendInitLoadTime,
  setMicrofrontendHostName,
  EMicrofrontendHostName,
} from '../../../../shared/Microfrontend';
import { getOffer } from '../../../../shared/ServicePickerWidget/services/getOffer';
import { setOffer } from '../../../../shared/ServicePickerWidget/actions/offer';
import { offerDefaultState } from '../../../../shared/ServicePickerWidget/reducers/offer';
import { getPerformanceNowTimeSec } from '../../../../shared/common/utils';
import { createRoot } from 'react-dom/client';

type TServicePickerWidgetMicrofrontendProps = {
  draftGuid?: string;
  id?: number;
  hostName?: EMicrofrontendHostName;
};

export const createMicrofrontendUI = (apiContext: IExtendedContext) => (): UIRuntimeBuilder => {
  const { store, ...context } = apiContext;
  const { httpApi, logger, config } = context;

  class ServicePickerWidget extends WebComponent<TServicePickerWidgetMicrofrontendProps> {
    protected microfrontendName = config.getStrict<string>('projectName');
    protected imageVersion = config.getStrict<string>('version.commit');
    protected runtimeName = '/public/v2/get-microfrontend/';

    private _prepareStore = async () => {
      const { id = null, draftGuid = null, hostName = null } = this.props;

      store.dispatch(setMicrofrontendInitLoadTime(getPerformanceNowTimeSec()));

      if (hostName) {
        store.dispatch(setMicrofrontendHostName(hostName));
      }

      if (id || draftGuid) {
        this.renderSkeleton();

        const offer = await getOffer({ httpApi, logger, realtyOfferId: id, draftGuid });

        store.dispatch(setOffer(offer || offerDefaultState));

        await updateServicePickerWidgetStore(store);
      }

      this.render(true);
    };

    public async connectedCallback() {
      await super.connectedCallback();

      await this._prepareStore();
    }

    public renderSkeleton() {
      const root = createRoot(this);

      root.render(<Skeleton />);
    }

    public async render(isAfterPrepareStore = false) {
      // НИКОГДА НЕ КОПИРУЙТЕ ЭТОТ КОД, ОН НУЖЕН ТОЛЬКО НАМ
      // рефакторинг будет в проекте https://jira.cian.tech/browse/MONEY-759
      if (isAfterPrepareStore) {
        const root = createRoot(this);

        root.render(<AppModulesWrapper context={context} reduxStore={store} />);
      }
    }
  }

  return {
    customElementConstructor: ServicePickerWidget,
  };
};
